



































import BaseComponent from '@/components/base/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { MenuAction } from '@/models/MenuAction.model';

@Component({})
export default class DropdownMenuComponent extends BaseComponent {

  // list of menu actions
  @Prop(Array)
  public menuActions!: MenuAction[];

  // dropdown open menu classes
  @Prop(String)
  public menuThumbnailImg!: string;

  // thumbnail img as dropdown open
  @Prop(String)
  public menuClasses!: string;

  // font awesome icon name for the menu
  @Prop({ type: String, default: 'ellipsis-v' })
  public faMenuIconName!: string;

  // font awesome icon type for the menu
  @Prop({ type: String, default: 'fas' })
  public faMenuIconType!: string;

  // material design icon name for the menu
  @Prop(String)
  public mdMenuIconName!: string;

  @Prop(Boolean)
  public isSubMenu!: boolean;

  private dropdownMenuId: string = '';

  private created() {
    const uuidv1 = require('uuid/v1');
    this.dropdownMenuId = 'menu' + uuidv1();
  }

  private itemClicked(menuAction: MenuAction): void {
    this.$emit('itemClicked', menuAction);
  }

  private onIconClicked(menuAction: MenuAction): void {
    this.$emit('iconClicked', menuAction);
  }

}
